/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{addMany as t}from"../../../core/SetUtils.js";import{valuesAreEquivalent as o}from"../../support/forms/formUtils.js";function r(r,e){const s=r??{},f=e??{},n=new Set(Object.keys(s));t(n,Object.keys(f));for(const t of n){const r=s[t],e=f[t];if(!o(r,e))return!1}return!0}export{r as attributesAreEquivalent};
